<template>
    <div>
        <i-form :model="nodeData" label-position="top">
            <form-item label="Título" prop="nome">
                <i-input v-model="nodeData.nome" placeholder="Título" size="large"></i-input>
            </form-item>
            <form-item label="Descrição" prop="descricao">
                <vue-editor v-model="nodeData.descricao" :editorToolbar="custom_toolbar" ></vue-editor>
            </form-item>
            <form-item label="Descrição Técnica" prop="descricao_tecnica">
                <vue-editor v-model="nodeData.descricao_tecnica" :editorToolbar="custom_toolbar" ></vue-editor>
            </form-item>
            <form-item label="Tipo" prop="tipo" v-if="!changeByPgd">
                <i-select size="large" v-model="nodeData.tipo">
                    <i-option v-for="tipo in tipos" :value="tipo.value" :key="tipo.value">
                        {{ tipo.label }}
                    </i-option>
                </i-select>
            </form-item>
            <form-item label="Owner" prop="owner_id" v-if="nodeData.tipo === 1">
                <i-select size="large" v-model="nodeData.owner_id">
                    <i-option v-for="pessoa in programadores"
                              :value="pessoa.value"
                              :key="pessoa.value">{{ pessoa.label }}
                    </i-option>
                </i-select>
            </form-item>
            <form-item label="Criticidade" prop="criticidade" v-if="nodeData.tipo === 3 && !changeByPgd">
                <Slider v-model="nodeData.criticidade" :min="1" :max="3" show-stops :tip-format="(val) => steps[val]"></Slider>
            </form-item>
            <form-item label="Arquivos" prop="arquivos" v-if="nodeData.tipo === 3">
                <vue-editor v-model="nodeData.arquivos" :editorToolbar="custom_toolbar" ></vue-editor>
            </form-item>
            <form-item label="Controllers" prop="controllers" v-if="nodeData.tipo === 3">
                <vue-editor v-model="nodeData.controllers" :editorToolbar="custom_toolbar" ></vue-editor>
            </form-item>
            <form-item label="Métodos" prop="metodos" v-if="nodeData.tipo === 3">
                <vue-editor v-model="nodeData.metodos" :editorToolbar="custom_toolbar" ></vue-editor>
            </form-item>
        </i-form>
    </div>
</template>

<script>
    import {editorToolbarMin} from "../helpers/utils.js";

    export default {
        name: "tree-node",
        props: {
            tipos: Array,
            programadores: Array,
            value: Object,
            changeByPgd:Boolean
        },
        components: {
            VueEditor: () =>
                import("vue2-editor").then(({VueEditor}) => VueEditor)
        },
        data() {
            return {
                steps: {
                    1: "BAIXA",
                    2: "MÉDIA",
                    3: "ALTA",
                },
                nodeData: {
                    id: 0,
                    pai_id: 0,
                    nome: "",
                    descricao: "",
                    descricao_tecnica: "",
                    tipo: 0,
                    owner_id: null,
                    criticidade: 0,
                    arquivos: "",
                    controllers: "",
                    metodos: "",
                },
                custom_toolbar: editorToolbarMin,
            }
        },
        mounted() {
            this.nodeData = this.value;
        },
        watch: {
            nodeData: function () {
                this.$emit("input", this.nodeData);
            },
            'nodeData.tipo'(val) {
                this.nodeData.criticidade = (val === 3) ?  1 : 0;
            }
        },
    }
</script>

<style scoped>

</style>
